<script module lang="ts">
	import type { ISbStoryData, SbBlokData } from '@storyblok/js';

	export interface AddToCartButtonProps extends SbBlokData {
		product_bundle_identifier: string;
		preselected_stripe_product: StripeProductData;
		button: Array<ISbStoryData<ButtonV3Props>>;
		open_cart?: boolean;
	}
</script>

<script lang="ts">
	import type { StripeProductData } from '$lib/storyblok/types';
	import type { ButtonV3Props } from '../buttonV3.svelte';
	import Blok from '$lib/storyblok/blok.svelte';
	import { checkoutSession } from '$lib/state/checkoutSession.svelte';
	import { shoppingCart } from '$lib/state/shoppingCart.svelte';
	import { trackEvent } from '$lib/segment/client';

	interface Props {
		content: ISbStoryData<AddToCartButtonProps>['content'];
	}

	let { content }: Props = $props();
</script>

{#each content.button as button}
	<Blok
		content={button}
		onclick={() => {
			checkoutSession.select(content.preselected_stripe_product, {
				productBundle: content.product_bundle_identifier
			});

			trackEvent('Product Added to Cart', {
				price_lookup_key: content.preselected_stripe_product.priceLookupKey
			});

			if (content.open_cart) {
				shoppingCart.open();
			}
		}}
	/>
{/each}
